import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

/**
 * A dropdown list of filters.
 *
 * @prop {{value: string, label: string, icon: ReactNode}[]} filterOptions an array of objects with a value and label
 * @prop {string} selectedFilter the currently selected filter
 * @prop {function} onFilterChange a function to call when the filter changes
 * @prop {boolean} [disabled] whether the filter options are disabled
 */
export const FilterOptions = ({ filterOptions = [], selectedFilter, onFilterChange, disabled = false }) => {
  const handleFilterChange = (event) => {
    const value = event.target.value;
    if (onFilterChange) {
      onFilterChange(value);
    }
  };

  return (
    <>
      <FormControl>
        <RadioGroup
          row
          value={selectedFilter}
          onChange={handleFilterChange}
          aria-labelledby="filter-buttons-group-label"
          name="filter-buttons-group"
        >
          {filterOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              disabled={disabled}
              control={
                <Radio
                  icon={<span style={{ fontSize: "0.9rem", marginRight: "0.2rem" }}>{option.icon}</span>}
                  checkedIcon={<span style={{ color: "#674BF5", fontSize: "0.9rem", marginRight: "0.2rem" }}>{option.icon}</span>}
                />
              }
              label={<span style={{ fontSize: "0.9rem", fontWeight: 600 }}>{option.label}</span>}
              sx={{
                "& .MuiRadio-root.Mui-checked + .MuiTypography-root": {
                  color: "#674BF5",
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};
